import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const RootContainer = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	width: 100vw;
	font-size: 0;
	min-width: 70rem;
	${props => props.borderPosition === 'top' && 'top: 0;'}
	${props => props.borderPosition === 'bottom' && 'bottom: 0;'}
`

const BorderElement = ({shapeElement: Shape, ...rest}) => <RootContainer
	{...rest}>
	<Shape/>
</RootContainer>

BorderElement.propTypes = {
	className: PropTypes.string,
	borderPosition: PropTypes.oneOf(['top', 'bottom']).isRequired,
}

BorderElement.defaultProps = {
	className: '',
}

export default BorderElement
